/** Fecha/hora límite de tareas asignadas (BNT Asistente / Equipo). */

/** Fin de jornada laboral por defecto (L–V 9:00–18:00 del despacho). */
export const DEFAULT_ASSIGNED_TASK_DUE_TIME = "18:00";

/**
 * Combina fecha (AAAA-MM-DD) y hora (HH:MM) para la API.
 * Sin fecha → null. Con fecha y sin hora → solo fecha (compatibilidad).
 */
export function composeAssignedTaskDue(dateValue, timeValue) {
  const date = String(dateValue || "").trim().slice(0, 10);
  if (!date) return null;
  const time = String(timeValue || "").trim().slice(0, 5);
  if (!time || !/^\d{2}:\d{2}$/.test(time)) return date;
  return `${date}T${time}`;
}

/** Etiqueta corta para listados: «2026-07-25 · 18:00» o solo fecha. */
export function formatAssignedTaskDueLabel(due) {
  const raw = String(due || "").trim();
  if (!raw) return "";
  if (raw.length <= 10) return raw.slice(0, 10);
  const datePart = raw.slice(0, 10);
  const timeMatch = raw.slice(10).match(/(\d{2}):(\d{2})/);
  if (!timeMatch) return datePart;
  return `${datePart} · ${timeMatch[1]}:${timeMatch[2]}`;
}
